import {
  MdExitToApp as LogoutIcon,
  MdSettings as SettingsIcon,
  MdShoppingCart as MyCartIcon,
  MdShopTwo as MyOrdersIcon
} from 'react-icons/md'
import logout from '@helpers/auth/logout'
import classnames from '@helpers/misc/classnames'
import {getSavedValue} from '@hooks/useSessionStorageState'
import useInitialData from '@page-components/Layout/useInitialData'
import useLayout from '@page-components/Order/useLayout'
import Link from 'next/link'
import {useTranslation} from 'next-i18next'

import useUserInfo from '../../hooks/useUserInfo.main'

import AdminLink from './AdminLink'
import AdminSalesPoinLink from './AdminSalesPointLink'

const UserMenuLinks = props => {
  const {me} = useUserInfo()
  const translatePrefix = 'layout.layouts.default.navbar.menu'
  const {t} = useTranslation('website')
  const {open} = props
  const cartLayoutType = useLayout()
  const {website} = useInitialData()

  const onLogout = async () => {
    await logout()
  }

  const isLoggedInWithExternalProviders = website => {
    const isOpenByWebview = getSavedValue('openByWebview')
    return (
      isOpenByWebview && website?.loginWithExternalProvidersAvailable?.includes(isOpenByWebview)
    )
  }

  const renderMenu = () => {
    if (!me) return null
    if (!open) return null

    const hideLogoutAndSettings = isLoggedInWithExternalProviders(website)
    const settingsURL = hideLogoutAndSettings ? '#' : '/settings'

    return (
      <div
        className={classnames(
          'z-500 absolute right-0 right-0 flex min-w-[230px] flex-col overflow-hidden rounded-lg bg-white shadow-lg',
          'dark:bg-zinc-700 ',
          {'md:right-[-200%]': cartLayoutType === 'v2'}
        )}
        key="menu">
        <Link
          href={settingsURL}
          passHref
          className={classnames(
            'block border-b border-neutral-200 text-center dark:border-zinc-600',
            userMenuLinkStyle
          )}>
          <div className="mb-1 text-base font-bold text-black dark:text-white">
            {me.name === 'Sin nombre' ? 'Mi cuenta' : me.name}
          </div>
          <div className="">{me.email}</div>
        </Link>
        <Link
          href={'/checkout'}
          className={classnames('flex flex-row space-x-3', userMenuLinkStyle)}>
          <MyCartIcon size={20} />
          <span>{t('fields.myCart', {ns: 'generic'})}</span>
        </Link>
        <Link href="/pedidos" className={classnames('flex flex-row space-x-3', userMenuLinkStyle)}>
          <MyOrdersIcon size={20} />
          <span>{t('fields.myOrders', {ns: 'generic'})}</span>
        </Link>
        {hideLogoutAndSettings ? null : (
          <Link
            href="/settings"
            className={classnames('flex flex-row space-x-3', userMenuLinkStyle)}
            target="_blank"
            rel="noopener noreferrer">
            <SettingsIcon size={20} />
            <span>{t(`${translatePrefix}.labelMyAccount`)}</span>
          </Link>
        )}
        <AdminLink />
        <AdminSalesPoinLink />
        {hideLogoutAndSettings ? null : (
          <a
            onClick={onLogout}
            className={classnames(
              userMenuLinkStyle,
              'flex flex-col border-t border-neutral-200 py-2 text-xs dark:border-zinc-600'
            )}>
            <LogoutIcon size={20} />
            <div>{t(`${translatePrefix}.labelLogOut`)}</div>
          </a>
        )}
      </div>
    )
  }

  return renderMenu()
}

export const userMenuLinkStyle =
  'text-neutral-700 text-sm items-center hover:bg-neutral-200 dark:text-white dark:hover:bg-zinc-600 p-4'

export default UserMenuLinks
